import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import Yup from '_zari/validation/_yup'

import { Button, Form, Modal } from '_zari/core'

import ListaDePaisesConstant from 'constants/listaDePaises'

import * as SociosCrud from 'services/socio.service'

import * as FormGroups from './formGroups'

const ValidationSchema = Yup.object().shape({
  _idPais: Yup.string().required(),
  direccion: Yup.string().min(5).max(200).required(),
  _idDepartamento: Yup.string().when('_idPais', {
    is: ListaDePaisesConstant.PERU.ISO2,
    then: Yup.string().required()
  }),
  _idProvincia: Yup.string().when('_idPais', {
    is: ListaDePaisesConstant.PERU.ISO2,
    then: Yup.string().required()
  }),
  _idDistrito: Yup.string().when('_idPais', {
    is: ListaDePaisesConstant.PERU.ISO2,
    then: Yup.string().required()
  })
})

const NuevaDireccionModal = ({ handleClose, show, idSocio, onCreate }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      direccion: '',
      _idPais: '',
      _idDepartamento: '',
      _idProvincia: '',
      _idDistrito: ''
    }),
    []
  )

  const submitHandler = async data => {
    SociosCrud.nuevaDireccion(idSocio, data)
      .then(({ data }) => {
        __zariContext.snack('success', 'La dirección se ha creado.')
        onCreate({ _id: data._id })
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>NUEVA DIRECCION</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, handleChange, setValues, touched, values }) => (
          <Form>
            <Modal.Body>
              <FormGroups.PaisFormGroup
                values={values}
                setValues={setValues}
                handleChange={handleChange}
                iError={errors._idPais}
                iTouched={touched._idPais}
                fIsSubmitting={isSubmitting}
              />
              {values._idPais === ListaDePaisesConstant.PERU.ISO2 ? (
                <>
                  <FormGroups.DepartamentoFormGroup
                    values={values}
                    setValues={setValues}
                    handleChange={handleChange}
                    iError={errors._idDepartamento}
                    iTouched={touched._idDepartamento}
                    fIsSubmitting={isSubmitting}
                  />
                  <FormGroups.ProvinciaFormGroup
                    values={values}
                    setValues={setValues}
                    handleChange={handleChange}
                    idDepartamento={values._idDepartamento}
                    iError={errors._idProvincia}
                    iTouched={touched._idProvincia}
                    fIsSubmitting={isSubmitting}
                  />
                  <FormGroups.DistritoFormGroup
                    values={values}
                    idProvincia={values._idProvincia}
                    iError={errors._idDistrito}
                    iTouched={touched._idDistrito}
                    fIsSubmitting={isSubmitting}
                  />
                </>
              ) : null}
              <FormGroups.DireccionFormGroup iError={errors.direccion} iTouched={touched.direccion} fIsSubmitting={isSubmitting} />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Crear</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(NuevaDireccionModal)
